<template>
    <div class="bottom-tools-comp" v-if="$route.path !== '/clients/cart'">
        <div class="full-navbar" :class="{ active: layout === 'full' }">
            <nav>
                <ul>
                    <li>
                        <router-link :to="dashboardLink">
                            <House />
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="shopLink">
                            <Store />
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="scannerLink" class="qr-highlight">
                            <QrCode />
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="studentsLink">
                            <Users />
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="settingsLink">
                            <CircleDollarSign v-if="isSchool" />
                            <Puzzle v-else />
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="searchbar" :class="{ active: layout === 'search' }">
            <div class="searchbar-content">
                <span>
                    <Search />
                </span>
                <input type="text" placeholder="Busque por avaliações...">
            </div>
            <ul>
                <li>
                    <router-link to="/settings">
                        <Plus />
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="split-navbar" :class="{ active: layout === 'split' }">
            <nav>
                <ul>
                    <li>
                        <router-link to="/home">
                            <House />
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/search">
                            <Search />
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/add">
                            <Plus />
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/tasks">
                            <CircleCheckBig />
                        </router-link>
                    </li>
                </ul>
                <ul>
                    <li>
                        <router-link to="/settings">
                            <Ellipsis />
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { House, Store, Users, Puzzle, Search, Plus, CircleCheckBig, Ellipsis, QrCode, CircleDollarSign } from 'lucide-vue-next';

export default {
    name: 'BottomToolComp',
    props: {
        layout: {
            type: String,
            default: 'full',
            validator: (value) => ['full', 'search', 'split'].includes(value)
        }
    },
    data() {
        return {
            clientId: '9899e9e239j29j2m9929n29h9j29m9'
        };
    },
    components: {
        House,
        Store,
        Users,
        Puzzle,
        Search,
        Plus,
        CircleCheckBig,
        Ellipsis,
        QrCode,
        CircleDollarSign
    },
    computed: {
        isSchool() {
            return this.$route.path.startsWith('/school/');
        },
        dashboardLink() {
            return this.isSchool ? '/school/dashboard' : '/clients/dashboard';
        },
        shopLink() {
            return this.isSchool ? '/school/shop' : '/clients/shop';
        },
        scannerLink() {
            return this.isSchool ? '/school/scanner' : ('/clients/' + this.clientId);
        },
        studentsLink() {
            return this.isSchool ? '/school/clients' : '/clients/students';
        },
        settingsLink() {
            return this.isSchool ? '/school/finance' : '/clients/settings';
        }
    },
    mounted() {
        const stored = localStorage.getItem('user');
        if (stored) {
            try {
                const user = JSON.parse(stored);
                if (user && user.id) {
                    this.clientId = user.id;
                }
            } catch (err) {
                console.error(err);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.bottom-tools-comp {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0px;
    width: 100%;
    z-index: 999999;
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 1024px) {
        display: none;
    }

    &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        mask-image: linear-gradient(to top, black 0%, transparent 100%);
        -webkit-mask-image: linear-gradient(to top, black 0%, transparent 100%);
        z-index: -1;
        pointer-events: none;
    }

    .full-navbar {
        display: none;
        width: 100%;

        nav {
            width: 100%;

            ul {
                width: 100%;
                list-style: none;
                display: flex;
                align-items: center;
                justify-content: space-between;
                // background-image: radial-gradient(#009eff, #0093ef);
                background-color: var(--orange);
                border-radius: 100px;
                backdrop-filter: blur(10px);
                -webkit-backdrop-filter: blur(10px);
                box-shadow: -.5px -.5px .5px 0px #ffffff33, .5px .5px .5px 0px #ffffff22;

                li {
                    padding: 6px;

                    a {
                        width: 43px;
                        height: 43px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        color: #ffffff;
                        position: relative; // Necessário para o badge

                        .msg-badge {
                            position: absolute;
                            top: -2px;
                            right: -2px;
                            min-width: 16px;
                            height: 16px;
                            padding: 0 4px;
                            background-color: #ff3b30; // Vermelho solicitado
                            color: white;
                            border-radius: 10px;
                            font-size: 10px;
                            font-weight: 800;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1.5px solid white;
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                        }

                        &.qr-highlight {
                            background-color: #005d97 !important;
                            color: white !important;
                            transform: scale(1.15) translateY(-8px);
                            box-shadow: 0 8px 20px rgba(0, 93, 151, 0.4);
                            border: 2px solid white;
                            z-index: 10;

                            &.router-link-active {
                                background-color: var(--blue) !important;
                                border-color: var(--yellow);
                            }
                        }
                    }
                }
            }
        }
    }

    .split-navbar {
        display: none;
        width: 100%;

        nav {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;

            ul {
                width: 100%;
                list-style: none;
                display: flex;
                align-items: center;
                justify-content: space-between;
                // background-image: radial-gradient(#009eff, #0093ef);
                background-color: var(--orange);
                border-radius: 100px;
                backdrop-filter: blur(10px);
                -webkit-backdrop-filter: blur(10px);
                box-shadow: -.5px -.5px .5px 0px #ffffff33, .5px .5px .5px 0px #ffffff22;

                &:first-child {
                    width: min-content;
                }

                &:last-child {
                    width: min-content;
                }

                li {
                    padding: 6px;

                    a {
                        width: 43px;
                        height: 43px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        color: #ffffff;
                    }
                }
            }
        }
    }

    .searchbar {
        display: none;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        gap: 12px;

        .searchbar-content {
            padding: 6px;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 6px;
            // background-image: radial-gradient(#009eff, #0093ef);
            background-color: var(--orange);
            border-radius: 100px;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            box-shadow: -.5px -.5px .5px 0px #ffffff33, .5px .5px .5px 0px #ffffff22;

            span {
                width: 43px;
                height: 43px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 100px;
                color: #ffffff;

            }

            input {
                background: transparent;
                border: none;
                outline: none;
                color: #ffffff;
                width: calc(100% - 43px);
                height: 43px;
                font-size: 16px;
                font-weight: light;

                &::placeholder {
                    color: #ffffff;
                }
            }
        }

        ul {
            width: min-content;
            list-style: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // background-image: radial-gradient(#009eff, #0093ef);
            background-color: var(--orange);
            border-radius: 100px;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            box-shadow: -.5px -.5px .5px 0px #ffffff33, .5px .5px .5px 0px #ffffff22;

            li {
                padding: 6px;

                a {
                    width: 43px;
                    height: 43px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    color: #ffffff;
                }

                .active-link {
                    background-color: var(--dark-04);
                }
            }
        }
    }

    .active {
        display: flex;
    }

    .active-link,
    .router-link-active {
        background-color: var(--yellow) !important;
        color: #005d97 !important;
    }
}
</style>